jQuery(document).ready(function($){
    // Find the article container
  var $articleContent = $('.article-template__content, .rte').first();
  var $tocContainer = $('.table-of-contents nav');

  if (!$articleContent.length || !$tocContainer.length) {
    return;
  }

  // Find all h2 and h3 headings
  var $headings = $articleContent.find('h2, h3');

  if (!$headings.length) {
    $('.table-of-contents').hide();
    return;
  }

  var tocHTML = '<ul>';

  $headings.each(function() {
    var $heading = $(this);
    var id = $heading.attr('id');

    if (!id) {
      id = $heading.text()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')          // Replace spaces with dashes
        .replace(/[^\w\-]+/g, '');     // Remove non-word characters
      $heading.attr('id', id);
    }

    var tag = this.tagName.toLowerCase();
    var indentClass = (tag === 'h3') ? 'toc-subitem' : '';

    tocHTML += '<li class="' + indentClass + '"><a href="#' + id + '">' + $heading.text() + '</a></li>';
  });

  tocHTML += '</ul>';

  $tocContainer.html(tocHTML);
  if ($(window).width() < 992) {
    $('.toc-wrapper h3').on('click',function(){
        if ($(this).hasClass('list-active')) {
            $tocContainer.slideUp();
            $(this).removeClass('list-active');    
        } else {
            $(this).addClass('list-active');
            $tocContainer.slideDown();
        }
    });
    }
  $tocContainer.find('a').on('click', function(e) {
    e.preventDefault();

    if ($(window).width() < 992) {
        $tocContainer.slideUp();
        $('.toc-wrapper h3').removeClass('list-active');
    }

    var targetId = $(this).attr('href');
    var $target = $(targetId);

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - 20 // adjust offset if needed
      }, 500); // 500ms duration
    }
  });
});